import { ThumbsDown, ThumbsUp, Minus } from 'lucide-react'
import { cn } from '@/utils/cn'

export function getNpsClassificacao(nota: number): string {
  if (nota >= 9) return 'PROMOTOR'
  if (nota >= 7) return 'NEUTRO'
  return 'DETRATOR'
}

export function getNpsColor(nota: number): string {
  if (nota >= 9) return 'text-emerald-400'
  if (nota >= 7) return 'text-yellow-400'
  return 'text-red-400'
}

export function getNpsBgColor(nota: number): string {
  if (nota >= 9) return 'bg-emerald-500/20 border-emerald-500/30'
  if (nota >= 7) return 'bg-yellow-500/20 border-yellow-500/30'
  return 'bg-red-500/20 border-red-500/30'
}

export function getHealthColor(score: number): string {
  if (score >= 70) return 'bg-emerald-500'
  if (score >= 40) return 'bg-yellow-500'
  return 'bg-red-500'
}

export function getHealthLabel(score: number): string {
  if (score >= 70) return 'Saudável'
  if (score >= 40) return 'Atenção'
  return 'Crítico'
}

export function getStatusBadge(status: string) {
  const map: Record<string, { label: string; className: string }> = {
    ATIVO: { label: 'Ativo', className: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' },
    ONBOARD: { label: 'Onboarding', className: 'bg-blue-500/20 text-blue-400 border-blue-500/30' },
    CANCELADO: { label: 'Cancelado', className: 'bg-red-500/20 text-red-400 border-red-500/30' },
  }
  return map[status] ?? { label: status, className: 'bg-white/10 text-white/60 border-white/20' }
}

export function NpsScoreBadge({ score }: { score: number }) {
  const Icon = score >= 9 ? ThumbsUp : score >= 7 ? Minus : ThumbsDown
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold border',
        getNpsBgColor(score),
        getNpsColor(score),
      )}
    >
      <Icon size={11} />
      {score} — {getNpsClassificacao(score)}
    </span>
  )
}

export type NpsStats = {
  media: number
  total: number
  promotores: number
  neutros: number
  detratores: number
  nps: number
}

export function computeNpsStats(scores: number[]): NpsStats {
  if (scores.length === 0) {
    return { media: 0, total: 0, promotores: 0, neutros: 0, detratores: 0, nps: 0 }
  }
  const total = scores.length
  const promotores = scores.filter((s) => s >= 9).length
  const neutros = scores.filter((s) => s >= 7 && s <= 8).length
  const detratores = scores.filter((s) => s <= 6).length
  const nps = total > 0 ? Math.round(((promotores - detratores) / total) * 100) : 0
  return {
    media: scores.reduce((a, b) => a + b, 0) / total,
    total,
    promotores,
    neutros,
    detratores,
    nps,
  }
}
